// extracted by mini-css-extract-plugin
export default {"section":"tr-z","sectionTitle":"ur-z","fieldWrapper":"vr-z","formField":"wr-z","disabled":"xr-z","formLabel":"yr-z"};